import React, { useEffect, useState } from "react";
import { useLanguage } from "./LanguageContext";
import { translateText } from "./translation";

const TranslatedText = ({ defaultText, defaultLanguage = "uk" }) => {
  const { language } = useLanguage();
  const [translatedText, setTranslatedText] = useState(defaultText);

  useEffect(() => {
    async function fetchTranslation() {
      if (language !== defaultLanguage) {
        const newText = await translateText(defaultText, language);
        setTranslatedText(newText);
      } else {
        setTranslatedText(defaultText);
      }
    }

    fetchTranslation();
  }, [language, defaultText, defaultLanguage]);

  return <>{translatedText}</>;
};

export default TranslatedText;
